import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import CardItem from "components/cardItem/catdItem";
import ContentCard from "modules/website/components/ContentCard_bk/ContentCard";

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) +
        el.clientHeight &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
function processLazy() {
  let lazyl = document.querySelectorAll(".lazyl");

  lazyl.forEach((ele, itx) => {
    //console.log(ele,'lazy on grid');
    if (isInViewport(ele)) {
      ele.setAttribute("data-visible", true);
      if (!ele.dataset.loaded) {
        ele.style.backgroundImage = "url('" + ele.dataset.image + "')";
        ele.setAttribute("data-loaded", true);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    processLazy();
  });
});

export default function GLIFOSCollectionGridViewer(props) {
  const [resultRecords, setresultRecords] = useState({
    loaded: false,
    photos: [],
  });

  useEffect(() => {
    // console.log(props?.mySelectedPhotos);
    setresultRecords({
      loaded: true,
      photos: props?.mySelectedPhotos?.payload,
    });
  }, [props?.mySelectedPhotos]);

  return (
    <div className="ggridv">
      {/* resultRecords.loaded && (
        <Row>
          {resultRecords.photos.map((xph, xi) => {
            return <CardItem data={xph} key={xi} />;
          })}
        </Row>
      ) */}
      {
        resultRecords.loaded && (
          <Row>
            {resultRecords.photos.map((xph, xi) => {
              //console.log(xph);
              return <ContentCard data={xph} key={xi} />;
            })}
          </Row>
        )
      }
    </div>
  );
}
